import { useMemo, useState } from 'react';

import { useBreakPoints } from 'core';
import { OneToTwoLayoutTemplate } from 'ui';
import { useDebouncedValue } from 'ui/Hooks';

import { useGetWalletActivity } from '../../../hooks/queries/Ledger/owner';
import { WalletBalanceCard } from './WalletBalanceCard';
import { EarningsContent } from './EarningsList';

const EarningsPage = () => {
  const { isMediumScreen } = useBreakPoints();
  const [search, setSearch] = useState('');
  const [debounced] = useDebouncedValue(search, 500);

  const { data } = useGetWalletActivity({
    queryOptions: {
      searches: {
        title: {
          value: debounced,
        },
      },
    },
  });

  const isEarningsEmpty = useMemo(
    () => !data?.pages[0].entries.length && !search,
    [data?.pages, search]
  );

  return (
    <OneToTwoLayoutTemplate
      showLeftSection={!isMediumScreen}
      leftSection={<WalletBalanceCard />}
      rightSection={
        <EarningsContent search={search} setSearch={setSearch} isEarningsEmpty={isEarningsEmpty} />
      }
    />
  );
};

export { EarningsPage };
